import '../../style.scss';
import { Selector, SelectorProps } from 'views/templates/module/selector';
import { InputTemplate, InputTemplateProps } from 'views/templates/module/inputTemplate';
import { OverseasRealEstateBusinessContentText } from 'views/utils/enums';
import { Caption } from 'views/mutual/caption';

type OverseasRealEstateFatcaBusinessContentProps = {
  businessContentSelectorProps: SelectorProps,
  businessContentOtherTextProps: InputTemplateProps | null,
}

export const OverseasRealEstateFatcaBusinessContent = ({businessContentSelectorProps, businessContentOtherTextProps}: OverseasRealEstateFatcaBusinessContentProps) => {
  return (
    <div className="business-content"> 
      <Caption label="１．事業内容についての確認" />    
      <div className="business-content_description-wrapper">
        <span className="business-content_description-wrapper_description">
          {'以下の業種選択肢（⓪～⑬）から貴社の事業内容をご選択ください。'}
        </span>
        <span className="business-content_description-wrapper_description">
          {'事業内容が複数ある場合は、主な事業についてご回答をお願いします。'}
        </span>
      </div>
      <div className="business-content_input">
        <Selector {...businessContentSelectorProps} />
        {businessContentOtherTextProps && (
          <div className="business-content_input_text">
            <span className="business-content_input_text_left">{`${OverseasRealEstateBusinessContentText.Sonohoka}の場合`}</span>
            <div className="business-content_input_text_right">
              <InputTemplate
                type="text"
                placeholder="内容を具体的にご記入ください"
                {...businessContentOtherTextProps}
              />
            </div>
          </div>
        )}
      </div>
    </div>        
  );
}